import { z } from 'zod';

const adsense = z.object({
    sequence: z.number(),
    number_of_ads: z.number(),
    style_id: z.string().optional(),
    channel_id: z.string().optional(),
    size: z.string().optional(),
    max_term_length: z.number().optional(),
});
const bidder = z.object({
    name: z.string(),
    params: z.record(z.union([z.string(), z.number()])),
});
const sizeEnum = z.enum(['fluid']);
const size = z.union([
    sizeEnum,
    z.string().regex(/^\d+x\d+$/, 'value not valid'),
]);
const gam = z.object({
    sequence: z.number(),
    unit_id: z.string(),
    sizes: z.array(size),
    custom_native: z
        .object({
        style: z.string().optional(),
        template_id: z.string().optional(),
    })
        .optional(),
    template_native: z
        .object({
        style: z.string(),
    })
        .optional(),
    bidding_systems: z
        .array(z.object({
        name: z.string().optional(),
        bidders: z.array(bidder),
    }))
        .optional(),
    refresh: z
        .object({
        interval: z.number(),
        enabled: z.boolean(),
    })
        .optional(),
});
const pageSettings = z.object({
    adsense: z
        .object({
        style_id: z.string().optional(),
        channel_id: z.string().optional(),
        max_term_length: z.number().optional(),
        pub_id: z.string(),
        ad_page: z.number().optional(),
        adsafe: z.enum(['high', 'medium', 'low']).optional(),
        link_target: z.enum(['_blank', '_top']).optional(),
        hl: z.string().optional(),
    })
        .optional(),
    gam: z.object({ content_url: z.unknown() }).optional(),
    frequency: z.number().optional(),
});
const slot = z.object({
    container_id: z.string(),
    name: z.string(),
    show_when_unfilled: z.string().optional(),
    configurations: z.object({
        adsense: z.array(adsense).optional(),
        gam: z.array(gam).optional(),
    }),
});
const config = z.object({
    id: z.string(),
    version: z.number(),
    name: z.string(),
    property: z.string(),
    vertical: z.string(),
    active: z.boolean(),
    premium_user: z.boolean().optional(),
    premium_ad: z.boolean().optional(),
    variant: z.string().optional(),
    slots: z.array(slot),
    page_level_settings: pageSettings,
});
z.object({
    variant: z.string().optional(),
    name: z.string().optional(),
    property: z.string().optional(),
    vertical: z.string().optional(),
    active: z.boolean().optional(),
    premium_user: z.boolean().optional(),
    premium_ad: z.boolean().optional(),
});
const configsResult = z.array(config);
const configsPageResult = config;
z.enum(['LISTING', 'AD_DETAIL', 'MANAGE_ADS']);
z.enum([
    'BELOW_PRICE',
    'BELOW_DESCRIPTION',
    'BELOW_HISTORY',
    'BELOW_FEATURES',
    'BELOW_ADVERTISER',
    'ASIDE',
    'NINTH_POSITION',
    'ADS_FILTERS',
    'TOP_ADS',
]);
z.enum(['web', 'm-site', 'android', 'ios']);

export { adsense, bidder, config, configsPageResult, configsResult, gam, pageSettings, slot };
//# sourceMappingURL=zod.js.map
